'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const evaluatePackageEligibility = _ref => {
  var _shipment$eligibility;
  let {
    state,
    allowMultiPackageClaims,
    shipment
  } = _ref;
  // If the item is ineligible for a reason coming from the API, prefer that reason
  if (!((_shipment$eligibility = shipment.eligibility) !== null && _shipment$eligibility !== void 0 && _shipment$eligibility.isEligible)) {
    var _shipment$eligibility2, _shipment$eligibility3, _shipment$eligibility4;
    return {
      isEligible: ((_shipment$eligibility2 = shipment.eligibility) === null || _shipment$eligibility2 === void 0 ? void 0 : _shipment$eligibility2.isEligible) ?? false,
      ineligibilityReason: ((_shipment$eligibility3 = shipment.eligibility) === null || _shipment$eligibility3 === void 0 ? void 0 : (_shipment$eligibility4 = _shipment$eligibility3.ineligibilityReasons) === null || _shipment$eligibility4 === void 0 ? void 0 : _shipment$eligibility4[0].reason) ?? null
    };
  }
  if (!allowMultiPackageClaims) {
    const claimOnAnotherPackageExists = Object.keys(state.packageClaims).some(packageClaimId => {
      const packageClaim = state.packageClaims[packageClaimId];
      return packageClaim.id !== shipment.id;
    });
    if (claimOnAnotherPackageExists) {
      return {
        isEligible: false,
        ineligibilityReason: 'SinglePackageClaimRestriction'
      };
    }
  }
  // Default to isEligible: true
  return {
    isEligible: true,
    ineligibilityReason: null
  };
};
const updateEvaluatedPackageEligibility = _ref2 => {
  let {
    state,
    allowMultiPackageClaims
  } = _ref2;
  if (!state.claimEligibilityInfo) throw new Error('Insufficient data to update shipment');
  return {
    ...state,
    claimEligibilityInfo: {
      ...state.claimEligibilityInfo,
      shipments: state.claimEligibilityInfo.shipments.map(shipment => ({
        ...shipment,
        evaluatedEligibility: evaluatePackageEligibility({
          state,
          allowMultiPackageClaims,
          shipment
        })
      }))
    }
  };
};

exports["default"] = updateEvaluatedPackageEligibility;
